import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import FolderIcon from '@mui/icons-material/Folder'

import { theme } from '../../themes/theme'
import { getFileSize } from '../../util/strings'
import { categoryStatuses } from '../../util/categoryConsts'
import { BoldBodyText, BoldFormTitle } from '../styles/Text'
import { FlexColumn, SpaceBetweenRowContainer } from '../styles/Containers'
import CategoryStatus from './CategoryStatus'

const CardContainer = styled(FlexColumn)`
  justify-content: space-between;
  height: 100%;
`

const FolderIconWrapper = styled.div`
  display: flex;
  color: ${theme.colors.text.body};

  .MuiSvgIcon-root {
    width: 44px;
    height: 36px;
    transform: scale(1.2);
    transform-origin: center;
  }
`

const CategoryName = styled(BoldFormTitle)`
  line-height: 22px;
  color: ${theme.colors.text.heading};
  word-break: break-word;
  text-transform: none;
`

const FooterText = styled(BoldBodyText)`
  font-size: 14px;
  line-height: 17px;
  color: ${theme.colors.text.body};
`

function CategoryCard({ name, status = null, numberOfFiles, size }) {
  const formattedFileSize = getFileSize(size).replace('.0 ', ' ')

  return (
    <CardContainer gap="10px">
      <FlexColumn gap="10px">
        <SpaceBetweenRowContainer>
          <FolderIconWrapper>
            <FolderIcon viewBox="0 0 24 21" />
          </FolderIconWrapper>
          {name !== 'Removed Files' && status && <CategoryStatus status={status} iconOnly />}
        </SpaceBetweenRowContainer>
        <CategoryName>{name}</CategoryName>
      </FlexColumn>
      <SpaceBetweenRowContainer>
        <FooterText>
          {numberOfFiles} {numberOfFiles === 1 ? 'file' : 'files'}
        </FooterText>
        <FooterText>{formattedFileSize}</FooterText>
      </SpaceBetweenRowContainer>
    </CardContainer>
  )
}

CategoryCard.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.oneOf(categoryStatuses),
  numberOfFiles: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired
}

export default CategoryCard
